import React, { useState } from "react";
import SigninWrapper from "../wrapper/SigninWrapper";
import Button from "../button/Button";
import InputField from "../Form/InputField";
import { useFormik } from "formik";
import { resetPasswordAPI } from "../../API/auth/PasswordAPI";
import { resetPasswordSchema } from "../../schema";
import ButtonLoader from "../button/ButtonLoader";

const initialState = {
  code: "",
  password: "",
  confirmPassword: "",
};
const NewPassword = ({ onNext, setStepValues, stepsValues }) => {
  const [loading, setLoading] = useState(false);
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        ...initialState,
        code: stepsValues.code || "", // Use code from previous step if available
      },
      validationSchema: resetPasswordSchema,
      onSubmit: async (values, { resetForm }) => {
        if (!stepsValues.email) {
          return;
        }
        setLoading(true);
        try {
          await resetPasswordAPI({
            email: stepsValues.email,
            code: values.code,
            password: values.password,
          });
          setStepValues({
            email: stepsValues.email,
            code: values.code,
            password: values.password,
          });
          resetForm();
          onNext();
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      },
    });

  return (
    <>
      <SigninWrapper headingText={"Reset Your Password"}>
        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
          <InputField
            label={"Verification Code"}
            id={"code"}
            name={"code"}
            type={"text"}
            placeholder={"Enter 6-digit code"}
            maxLength={6}
            value={values.code}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.code}
            touch={touched.code}
          />
          <InputField
            label={"New Password"}
            id={"password"}
            name={"password"}
            type={"password"}
            placeholder={"Enter your new password"}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.password}
            touch={touched.password}
          />
          <InputField
            label={"Confirm New Password"}
            id={"confirmPassword"}
            name={"confirmPassword"}
            type={"password"}
            placeholder={"Confirm your new password"}
            value={values.confirmPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.confirmPassword}
            touch={touched.confirmPassword}
          />
          {loading ? (
            <div className="flex justify-center items-center">
              <ButtonLoader />
            </div>
          ) : (
            <Button type={"submit"} text={"Reset Password"} />
          )}
        </form>
      </SigninWrapper>
    </>
  );
};

export default NewPassword;
